import styled from 'styled-components';

const CountrySelectorItem = styled.li`
  padding-left: 10px;
  height: 32px;
  line-height: 32px;

  &:hover {
    background-color: #999;
  }
`;

export default CountrySelectorItem;
